import FormCore from 'components/Form/Core';
import { Icon } from 'components/Icon';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { FormSpacing } from 'screens/FinancingProposalNew/styled';
import { Title } from 'ui/styled';
import { theme } from 'ui/theme-color';
import { formatPercentage } from 'utils/parsers';
import { InfoPMT, InfoPMTMessage } from './style';
import { defaultProposalSimulation, defaultTaxSimulation } from './utils';

export const FinancingSimulator = ({ installmentValue }) => {
  const refFormSimulation = useRef();

  const handleInitialSimulationValues = useCallback(() => {
    refFormSimulation.current.setItem(
      formatPercentage(defaultTaxSimulation.perc_taxa),
      'taxa'
    );
    refFormSimulation.current.setItem(
      defaultProposalSimulation.prazo_financiamento,
      'qtd_parcelas'
    );
    refFormSimulation.current.setItem(
      defaultProposalSimulation.carencia,
      'carencia'
    );
    refFormSimulation.current.setItem(
      defaultProposalSimulation.valor_venda,
      'valor_parcela'
    );
  }, []);

  useEffect(() => {
    handleInitialSimulationValues();
  }, [handleInitialSimulationValues]);

  const formSimulation = useMemo(
    () => [
      {
        ref: 'qtd_parcelas',
        placeholder: 'Quantidade de Parcelas',
        tress: true,
        disabled: true,
      },
      {
        ref: 'carencia',
        placeholder: 'Carência',
        tress: true,
        disabled: true,
      },
      {
        ref: 'valor_parcela',
        placeholder: 'PMT',
        tress: true,
        type: 'money',
        required: false,
        transparent: false,
        readOnly: true,
        value: installmentValue ?? 0,
        style: {
          backgroundColor:
            installmentValue === 0
              ? theme.palette.colors.lightgrey
              : theme.palette.purple.main,
          color: theme.palette.purple.contrastText,
          transition: 'background-color 0.5s ease',
        },
      },
    ],
    [installmentValue]
  );

  return (
    <>
      <Title small nomargin>
        Simulação
      </Title>
      <FormCore ref={refFormSimulation} formItems={formSimulation} />
      {!!installmentValue && (
        <InfoPMT>
          <InfoPMTMessage>
            <Icon name={'info'} size={20} />
            <span>
              O valor da parcela pode sofrer alterações na efetivação do
              contrato de acordo com o perfil do cliente.
            </span>
          </InfoPMTMessage>
        </InfoPMT>
      )}
      <FormSpacing />
    </>
  );
};
